import { isEmpty } from 'lodash';

import { PatientGroupAssignmentGroup } from '@dreryk/egabinet-patient-frontend-api';

import { HexColorDot, HexColorDotSize, Tooltip } from '@dreryk/react-components';

import { StyledPatientGroups } from './PatientGroups.styled';
import { PatientGroupMoreDot } from './PatientGroupMoreDot';
import { PatientGroupsTooltipContent } from './PatientGroupsTooltipContent';

const MAX_VISIBLE_DOTS = 5;
const DOTS_VISIBLE_WHEN_OVERFLOW = 4;
const MAX_COUNTER_VALUE = 99;

type PatientGroupsProps = {
   patientGroups: PatientGroupAssignmentGroup[];
   direction?: 'row' | 'column';
};

export const PatientGroups = (props: PatientGroupsProps): JSX.Element | null => {
   if (isEmpty(props.patientGroups)) {
      return null;
   }

   const shouldShowOverlapDot = props.patientGroups.length > MAX_VISIBLE_DOTS;
   const visibleDots = shouldShowOverlapDot
      ? props.patientGroups.slice(0, DOTS_VISIBLE_WHEN_OVERFLOW)
      : props.patientGroups;
   const hiddenDotsCount = Math.min(props.patientGroups.length - DOTS_VISIBLE_WHEN_OVERFLOW, MAX_COUNTER_VALUE);

   return (
      <Tooltip testId={'patientGroups'} content={<PatientGroupsTooltipContent patientGroups={props.patientGroups} />}>
         <StyledPatientGroups direction={props.direction} alignItems={'center'}>
            {visibleDots.map((group) => (
               <HexColorDot
                  key={group.id}
                  testId={group.id}
                  color={group.primaryColor.asHexString()}
                  darkModeColor={group.darkModeColor?.asHexString()}
                  size={HexColorDotSize.SMALL}
               />
            ))}
            {shouldShowOverlapDot ? <PatientGroupMoreDot counter={hiddenDotsCount} /> : null}
         </StyledPatientGroups>
      </Tooltip>
   );
};
